import React, { lazy, memo, Suspense } from 'react';
import { HyperlinkPlaceholder } from '../hyperlink/hyperlink-placeholder.tsx';
import styles from '../hyperlink/hyperlink-value-view.module.css';
import { type PageLinkReadContent } from './page-link-read-content.ts';

const SmartCard = lazy(() =>
  import('../hyperlink/hyperlink-smart-card.tsx').then((module) => ({
    default: module.HyperlinkSmartCard
  }))
);

/**

 * Page references use V1's empty loading label and the existing provider's Smart Card.

 */
export const PageLinkValueView = memo(function PageLinkValueView({
  content,
  showDisabledValue = false,
  noFocus = false
}: {
  readonly content: PageLinkReadContent;
  readonly showDisabledValue?: boolean;
  readonly noFocus?: boolean;
}) {
  return (
    <ul className={styles.value}>
      {content.links.map((link) => (
        <li key={link.key}>
          {link.resolve ? (
            <Suspense
              fallback={
                <HyperlinkPlaceholder
                  link={link}
                  showIcon={false}
                  showDisabledValue={showDisabledValue}
                />
              }
            >
              <SmartCard
                link={link}
                showDisabledValue={showDisabledValue}
                noFocus={noFocus}
              />
            </Suspense>
          ) : (
            <HyperlinkPlaceholder
              link={link}
              asLink
              noFocus={noFocus}
              showDisabledValue={showDisabledValue}
            />
          )}
        </li>
      ))}
    </ul>
  );
});
